import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { App_FormBloc, App_FormCreatorJson, App_FormSketchFormDynamique, App_FormStep } from 'src/app/utils/interfaces';
import { Type_App_Validator, Type_FieldOrLabel } from 'src/app/utils/types';

@Component({
  selector: 'app-c-form-dynamique-all-fields',
  templateUrl: './c-form-dynamique-all-fields.component.html',
  styleUrls: ['./c-form-dynamique-all-fields.component.scss'],
})
export class CFormDynamiqueAllFieldsComponent implements OnInit, OnDestroy {
  @Input({ required: true }) modeShow!: boolean;
  @Input({ required: true }) forms!: FormGroup;
  @Input({ required: true }) blocName!: string;
  @Input({ required: true }) fieldOrLabel!: Type_FieldOrLabel;
  @Input() etatId?: number;
  @Input({ required: true }) display!: App_FormCreatorJson; // TODO-pf? retirer + remplacer quand et si pertinent
  @Input({ required: true }) context!: 'preparation' | 'edition'; // TODO-pf? retirer + remplacer quand et si pertinent

  @Input({ required: true }) observeSourcesArrFromParentPage!: { formControl: FormControl; validator: Type_App_Validator; }[]; // TODO-pf? retirer + remplacer quand et si pertinent

  @Input({ required: true }) step!: App_FormStep // TODO-pf? retirer + remplacer quand et si pertinent
  @Input({ required: true }) bloc!: App_FormBloc // TODO-pf? retirer + remplacer quand et si pertinent

  @Input({ required: true }) mainFormOrSubForm!: 'main-form' | 'sub-form'

  @Output() triggerAlert = new EventEmitter<{ data: string }>();

  @Output() fieldSketchFormArraySubGroupEditor = new EventEmitter<{ formSketchFormDynamique: App_FormSketchFormDynamique, formGroup: FormGroup, blocName: string, step: App_FormStep, bloc: App_FormBloc }>();

  formControl: any;
  
  destroyedComponent$ = new Subject();

  constructor() { }

  ngOnInit() {
    if (this.fieldOrLabel.name) {
      this.formControl = this.forms.controls[this.fieldOrLabel.name];
      if (this.formControl instanceof AbstractControl) {
        this.formControl.valueChanges.pipe(
          takeUntil(this.destroyedComponent$),
          distinctUntilChanged()
        ).subscribe(e => {
          this.formControl.setValue(e);
        })
      }
    }
  }

  ngOnDestroy() {
    this.destroyedComponent$.next(true);
  }

  cascadeTriggerAlert($event: any) {
    this.triggerAlert.emit($event);
  }

  cascadeFormArraySubGroupEditor($event: { formSketchFormDynamique: App_FormSketchFormDynamique, formGroup: FormGroup, blocName: string, step: App_FormStep, bloc: App_FormBloc }) {
    this.fieldSketchFormArraySubGroupEditor.emit($event)
  }

}
